import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { ChartDimensionState } from '@kaizenplatform/kaizen-chartjs';

export const setLiftUpReportDimensionKeyState = (liftUpReportDimensionKeyState: ChartDimensionState[]) =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportDimensionKeyState.data = liftUpReportDimensionKeyState;
  });

export const disposeLiftUpReportDimensionKeyState = () =>
  produce((draft: Draft<State>) => {
    draft.liftUpReportDimensionKeyState.data = initialState.liftUpReportDimensionKeyState.data;
  });
